import $ from 'jquery'

$(document).ready(function() {
  co_vc_mietpark()
})

function co_vc_mietpark() {
  $('.co_vc_mietpark').each(function() {})
}
